<kendo-upload saveUrl="/api/core/files"
              [multiple]="false"
              (upload)="uploadEventHandler($event)"
              [restrictions]="fileRestrictions"
              (success)="successEventHandler($event)"
              (error)="errorEventHandler($event)">
    <ng-template kendoUploadFileTemplate let-files let-state="state">
        <p class="name" *ngIf="fileId && this.originalName">
            {{this.originalName}}<i class="bx bx-x" (click)="removeAfterUpload()"></i>
        </p>
    </ng-template>
</kendo-upload>
